<section class="z-30 pb-14 pt-8 w-full mt-0">
  <h3 class="text-2xl font-bold pb-6">
    {{ "shared.share_article" | translate }}
  </h3>
  <share-buttons
    [include]="['facebook', 'x', 'linkedin', 'messenger', 'whatsapp']"
    [theme]="'outline'"
  >
  </share-buttons>
</section>
